import { render, staticRenderFns } from "./nationality.vue?vue&type=template&id=988e4854&"
import script from "./nationality.vue?vue&type=script&lang=js&"
export * from "./nationality.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports